import { OcppLog } from './ocpp-log.model';

export class OcppLogModel {
    LocalizedTimestamp: string;
    DateTime: Date;
    StationId: string;
    Type: number; // Error = 0, Info = 1
    MessageType: string;
    MessageDirection: string;
    Message: string;
    MessageId: string;
    IsOcppMessage: boolean;

    constructor(ocppLog: OcppLog) {
        this.DateTime = new Date(ocppLog.Timestamp);
        this.StationId = ocppLog.StationId;
        this.Type = ocppLog.Type;
        this.Message = ocppLog.Message;
        this.MessageType = '';
        this.MessageDirection = '';
        this.MessageId = '';
        this.IsOcppMessage = false;

        this.LocalizedTimestamp = this.DateTime.toLocaleDateString() + ' ' + this.DateTime.toLocaleTimeString();

        this.tryParse();
    }

    private tryParse() {
        try {
            const splittedMessage = this.Message.split(':');

            // get message direction
            if (splittedMessage[0]) {
                // abort if not in the right format
                if (!splittedMessage[0].trim().startsWith('<-') && !splittedMessage[0].trim().startsWith('->')) {
                    return;
                }

                this.MessageDirection = splittedMessage[0].trim();
            }

            let message = '';

            // get pure ocpp message
            if (splittedMessage.length > 1) {
                let count = 0;
                splittedMessage.forEach(el => {
                    if (count !== 0) {
                        if (count !== splittedMessage.length - 1) {
                            message = message + el + ':';
                        } else {
                            message = message + el;
                        }
                    }
                    count++;
                });

                message = message.trim();
                this.Message = message;
                this.IsOcppMessage = true;
            }

            // get message id / message type
            if (message) {
                const messageSub = message.substr(1, message.length - 2).trim();
                const splittedMessageSub = messageSub.split(',');

                const requestResponseType = splittedMessageSub[0].trim();
                const messageId = splittedMessageSub[1].trim();

                this.MessageId = messageId;

                if (requestResponseType === '2') {
                    this.MessageType = splittedMessageSub[2].trim().substring(1, splittedMessageSub[2].length - 2);
                }
            }
        } catch (ex) {
            // parse error
        }
    }
}
